(function(){
"use strict";
var dati;
try{ dati=JSON.parse(document.getElementById("dtDati").textContent); }catch(e){ return; }
if(!dati||!dati.length)return;

var range=document.getElementById("dtRange");
var cifra=document.getElementById("dtBudget");
var quanti=document.getElementById("dtQuanti");
var ris=document.getElementById("dtRis");
var vuoto=document.getElementById("dtVuoto");
if(!range||!ris)return;

/* il cursore parte dal prezzo piu' basso del catalogo, non da un numero
   inventato: cosi' resta sensato anche se cambi i prezzi */
var prezzi=dati.map(function(p){return p.prezzo}).sort(function(a,b){return a-b});
var min=Math.floor(prezzi[0]/10)*10;
var max=Math.ceil(prezzi[prezzi.length-1]/10)*10;
range.min=min; range.max=max;
range.value=Math.round((min+max)/2/10)*10;

function euro(n){return "\u20ac"+Number(n).toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}

function rata(tot){
 if(!window.DemaRate)return "";
 var y=window.DemaRate.younited(tot);
 if(y)return "da <b>"+window.DemaRate.euro(y.rata)+"</b>/mese";
 var k=window.DemaRate.klarna(tot);
 if(k)return "3 rate da <b>"+window.DemaRate.euro(k.tre)+"</b>";
 return "";
}

var ultimo=null;
function disegna(){
 var b=Number(range.value);
 cifra.textContent=b.toLocaleString("it-IT");

 /* riempimento colorato del cursore */
 var p=((b-range.min)/(range.max-range.min))*100;
 range.style.setProperty("--p",p+"%");

 var dentro=dati.filter(function(x){return x.prezzo<=b})
                .sort(function(a,b2){return b2.prezzo-a.prezzo})
                .slice(0,4);

 quanti.textContent=dati.filter(function(x){return x.prezzo<=b}).length;

 var firma=dentro.map(function(x){return x.url}).join("|");
 if(firma===ultimo)return;
 ultimo=firma;

 if(!dentro.length){ ris.innerHTML=""; vuoto.hidden=false; return; }
 vuoto.hidden=true;

 ris.innerHTML=dentro.map(function(x,i){
  return '<a class="r" href="'+x.url+'" style="animation-delay:'+(i*0.06)+'s">'+
   '<div class="foto">'+
    (x.badge?'<span class="et">'+x.badge+'</span>':'')+
    (x.foto?'<img src="'+x.foto+'" alt="'+x.nome+'" loading="lazy">':'')+
   '</div>'+
   '<h3>'+x.nome+'</h3>'+
   '<div class="pz">'+euro(x.prezzo)+'</div>'+
   '<div class="rt">'+rata(x.prezzo)+'</div>'+
   '<span class="vai">Scoprilo <svg viewBox="0 0 24 24" width="13" height="13" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'+
  '</a>';
 }).join("");
}

range.addEventListener("input",disegna);
disegna();
setTimeout(disegna,400);
})();
